<script setup>
import {onClickHashLink} from "../../../Helpers/helper";

const list = [
    'Подробная квента',
    'Жизненные показатели, статы, спасброски',
    'Навыки',
    'Уникальные способности',
    'Заклинания и&nbsp;ячейки заклинаний',
    'Инвентарь',
    'Игровые заметки',
    'Баффы и&nbsp;дебаффы',
    'Экипировка и&nbsp;снятие предметов',
    'Использование способностей',
    'Автопересчёт значений',
    'Поиск',
    'Переключение между персонажами',
]
</script>

<template>
    <section id="player" class="group section-screen mt-6 xl:mt-4 pb-7 lg:pb-14 relative">
        <div class="relative max-w-full w-[1536px] mx-auto px-6 mt-[5.2rem]">
            <div class="relative px-6 lg:absolute lg:px-0 lg:top-0 lg:right-0 lg:w-3/5">
                <div class="w-[110%] md:w-[80%] translate-x-[20%] lg:translate-x-[6%] top-0 right-[1.5%] lg:max-w-[100%] lg:w-[794px] -z-10">
                    <svg width="100%" height="100%" viewBox="0 0 794 794"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         class="w-full opacity-0 transition-all duration-500 group-[.visited]:opacity-100"
                    >
                        <path d="M381.693 3.34051C391.494 -0.719247 402.506 -0.719252 412.307 3.34051L664.535 107.817C674.336 111.877 682.123 119.663 686.183 129.465L790.659 381.693C794.719 391.494 794.719 402.506 790.659 412.307L686.183 664.535C682.123 674.336 674.336 682.123 664.535 686.183L412.307 790.659C402.506 794.719 391.494 794.719 381.693 790.659L129.465 686.183C119.664 682.123 111.877 674.336 107.817 664.535L3.34051 412.307C-0.719247 402.506 -0.719252 391.494 3.34051 381.693L107.817 129.465C111.877 119.664 119.663 111.877 129.465 107.817L381.693 3.34051Z"
                              fill="url(#player-polygon-pattern)"/>
                        <defs>
                            <pattern id="player-polygon-pattern" width="100%" height="100%">
                                <image id="player-polygon-image" width="100%" xlink:href="/images/polygon-2.png" class="transition-transform duration-[10s] origin-center scale-110 group-[.visited]:scale-100"/>
                            </pattern>
                        </defs>
                    </svg>
                </div>
                <div class="screen-dice-wrapper absolute h-[88%] left-6 max-w-[40%] md:max-w-[30%] top-2/3 -translate-y-1/2 lg:left-1/2 lg:-translate-x-1/2 lg:top-1/2 lg:translate-y-[5%] lg:max-w-[38%] duration-1000 opacity-0 transition-opacity group-[.visited]:opacity-100">
                    <img src="/images/phone-3.png" alt="" class="max-w-full max-h-full mx-auto transition-transform duration-1000 translate-x-[20%] group-[.visited]:translate-x-0 dark:hidden">
                    <img src="/images/phone-3-dark.png" alt="" class="max-w-full max-h-full mx-auto transition-transform duration-1000 translate-x-[20%] group-[.visited]:translate-x-0 hidden dark:block">

                    <div class="screen-dice d4"></div>
                    <div class="screen-dice d6"></div>
                    <div class="screen-dice d8"></div>
                    <div class="screen-dice d10"></div>
                    <div class="screen-dice d20"></div>
                </div>
            </div>
            <div class="lg:w-1/2">
                <div class="pt-16 lg:pt-[2.8rem] lg:pr-[17%]">
                    <div class="text-xs md:text-md lg:text-lg my-1 md:my-3 text-blue-light">&mdash; игрокам</div>
                    <div class="text-3xl -tracking-[0.04em] lg:text-5xl xl:text-6xl font-extrabold leading-none text-black dark:text-white">Чарлисты</div>
                    <div class="mt-5 text-sm md:mt-7 md:text-xl xl:text-2xl !leading-normal">
                        Твои игровые личности теперь постоянно с&nbsp;тобой, выбирай любую
                        и&nbsp;вперёд искать приключения на&nbsp;свои пятые точки. Только дайсы не&nbsp;забудь!
                    </div>
                </div>
            </div>
            <div class="lg:w-1/2 mt-7 lg:mt-12 lg:relative">
                <div class="text-xl md:text-3xl lg:text-[2.5rem] font-bold leading-none tracking-tighter text-black dark:text-white">Уже сейчас:</div>
                <ul class="text-sm md:text-md lg:text-[1rem] mt-3 md:mt-6 list-disc leading-[2em] text-blue-light pl-3 md:pl-6">
                    <li v-for="item in list" v-html="item"></li>
                </ul>
                <a href="/#subscribe" class="btn mt-8 md:mt-16 text-blue-light" @click="onClickHashLink">
                    <span class="btn-text">Это мы хотим</span>
                    <span class="btn-hover-wrapper">
                        <span class="btn-hover">
                            <span>Это мы хотим</span>
                        </span>
                    </span>
                </a>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    #player .screen-dice {
        &.d4 {
            @apply top-[85%] left-[85%] lg:top-[0%] lg:left-[85%];
        }

        &.d6 {
            @apply hidden;
        }

        &.d8 {
            @apply hidden;
        }

        &.d10 {
            @apply bottom-[70%] right-[55%] lg:bottom-[15%] lg:right-[90%];
        }

        &.d20 {
            @apply -top-[45%] left-[30%] lg:top-[80%] lg:left-[30%];
        }
    }
</style>
